import {TOGGLE_DARK_MODE} from "../../actions/actionTypes";

const initialState = {
    data : localStorage.getItem('isDark')===null ?
        (window.matchMedia("(prefers-color-scheme: dark)") &&  !document.body.classList.contains('lightMode') )
        || (window.matchMedia("(prefers-color-scheme: light)") &&  document.body.classList.contains('darkMode') )
        : Boolean(localStorage.getItem('isDark'))
    ,
    loading:false,
    error : null
}

export default function darkModeReducer (state = initialState, action) {
    switch(action.type){
        case TOGGLE_DARK_MODE:
            localStorage.setItem('isDark', !state.data);
            return {
                ...state ,
                data : !state.data
            }
        default: return state
    }
}

